/*------------------------------------------------
// File Name:PDM_BodyCheck_Item.js
// File Description:PDM_BodyCheck_Item store方法
// Author:zxl
// Create Time:2023/04/17 21:05:54
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_ItemList,
    GetPDM_BodyCheck_ItemListByPage,
    GetPDM_BodyCheck_ItemEntity,
    CreatePDM_BodyCheck_ItemEntity,
    UpdatePDM_BodyCheck_ItemEntity,
    DeletePDM_BodyCheck_ItemEntity,
} from '@/api/pdm/bodycheckItem'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckItem = {
    namespaced: true,
    state: {
        PdmBodycheckItemList: [],
        PdmBodycheckItemListLoading: false,
        PdmBodycheckItemEntity: null,
        PdmBodycheckItemShowDlg: false,
    },
    mutations: {
        setPdmBodycheckItemList(state, dataList) {
            state.PdmBodycheckItemList = [...dataList]
        },
        setPdmBodycheckItemListLoading(state, visible) {
            state.PdmBodycheckItemListLoading = visible
        },
        setPdmBodycheckItemShowDlg(state, visible) {
            state.PdmBodycheckItemShowDlg = visible
        },
        setPdmBodycheckItemEntity(state, entity) {
            state.PdmBodycheckItemEntity = entity
        },
    },
    actions: {
        //创建套餐项目表对象
        actCreatePdmBodycheckItem({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckItemEntity', res.Data)
                        commit('setPdmBodycheckItemShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载套餐项目表对象
        actGetPdmBodycheckItemEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckItemListLoading', true)
                GetPDM_BodyCheck_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckItemEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载套餐项目表列表
        actGetPdmBodycheckItemList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckItemListLoading', true)
                GetPDM_BodyCheck_ItemList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckItemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载套餐项目表列表
        actGetPdmBodycheckItemListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckItemListLoading', true)
                GetPDM_BodyCheck_ItemListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckItemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存套餐项目表信息
        actUpdatePdmBodycheckItem({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckItemShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_Item
        actEditPdmBodycheckItemData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckItemID : entity.PdmBodycheckItemID
                }
                GetPDM_BodyCheck_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckItemEntity', res.Data)
                        commit('setPdmBodycheckItemShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_Item ,传对象过来
        actEditPdmBodycheckItem({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckItemEntity', entity)
                commit('setPdmBodycheckItemShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_Item
        actDeletePdmBodycheckItem({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前套餐项目表？").onOk(() => {
                    DeletePDM_BodyCheck_ItemEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckItemShowDlg', false)
                           
                            msg.success("删除套餐项目表成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除套餐项目表失败，原因:" + res.Message)
                            //msg.success("删除套餐项目表失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


